import React, { Component } from 'react';
import { observer } from 'mobx-react';

import {
  RESMIO_LEGAL_NOTICE_URL,
  RESMIO_PRIVACY_POLICY_URL,
  RESMIO_TERMS_CONDITIONS_B2C_URL,
  ORDERBIRD_LEGAL_NOTICE_URL,
  ORDERBIRD_PRIVACY_POLICY_URL,
  ORDERBIRD_TERMS_CONDITIONS_URL,
  RESMIO_URL,
  ORDERBIRD_URL,
  RESMIO_ACCESSIBILITY_URL,
} from 'app/constants';
import ResmioIcon from 'app/commonComponents/icons/ResmioIcon';
import OrderbirdIcon from 'app/commonComponents/icons/OrderbirdIcon';

import config from '../../config';

import { LeftBlock, Policy, PolicyLink } from './styles';

const FacilityDetails = observer(() => {
  return (
    <LeftBlock>
      {config.isOrderbirdFacility ? (
        <a
          href={ORDERBIRD_URL}
          target="_blank"
          style={{ marginTop: '-10px', paddingRight: '5px' }}
          aria-label={i18n.gettext('Orderbird')}
        >
          <OrderbirdIcon style={{ margin: '0 0.5rem' }} aria-hidden="true" />
        </a>
      ) : (
        <a
          href={RESMIO_URL}
          target="_blank"
          aria-label={i18n.gettext('Resmio')}
          style={{ paddingRight: '5px' }}
        >
          <ResmioIcon height="100%" width="120px" aria-hidden="true" />
        </a>
      )}
      <Policy>
        <PolicyLink
          href={
            config.isOrderbirdFacility
              ? ORDERBIRD_LEGAL_NOTICE_URL
              : RESMIO_LEGAL_NOTICE_URL
          }
          target="_blank"
        >
          {i18n.gettext('Legal Notice')}
        </PolicyLink>
        {' | '}
        <PolicyLink
          href={
            config.isOrderbirdFacility
              ? ORDERBIRD_PRIVACY_POLICY_URL
              : RESMIO_PRIVACY_POLICY_URL
          }
          target="_blank"
        >
          {i18n.gettext('Privacy Policy')}
        </PolicyLink>
        {' | '}
        <PolicyLink
          href={
            config.isOrderbirdFacility
              ? ORDERBIRD_TERMS_CONDITIONS_URL
              : RESMIO_TERMS_CONDITIONS_B2C_URL
          }
          target="_blank"
        >
          {i18n.gettext('Terms & Conditions')}
        </PolicyLink>
        {' | '}
        <PolicyLink href={RESMIO_ACCESSIBILITY_URL} target="_blank">
          {i18n.gettext('Accessibility')}
        </PolicyLink>
      </Policy>
    </LeftBlock>
  );
});

export default FacilityDetails;
